<template>
  <div class="nav-wrapper nav nav--fixed" :class="isMenuCollapsed ? 'nav--collapsed' : 'nav--expanded'">
    <div class="nav__menu-toggle">
      <el-button class="toggle-button" @click="collapseMenuIfOnMobile">
        <icon name="bars"></icon>
      </el-button>
    </div>

    <router-link class="u-text--center" v-if="!isMenuCollapsed" @click="collapseMenuIfOnMobile" to="/company-select">
      <img class="nav__logo nav__logo--img u-img-responsive" alt="BriteApps" src="../assets/briteappslogonotagline.png">
      <el-tag type="success" v-if="isFeatureEnabled('is-local')">local</el-tag>
      <el-tag type="success" v-if="isFeatureEnabled('is-dev')">dev</el-tag>
    </router-link>
    <notification-widget v-if="!isMenuCollapsed && isSuperuser"></notification-widget>
    <router-link v-if="companyNameById(companyId)" @click="collapseMenuIfOnMobile" :disabled="isMenuCollapsed" to="./"
                 :class="{ 'nav__link--active' : activeModule === 'dashboard', 'u-mb2' :  !isMenuCollapsed, 'hidden-company': disableMenu}"
                 class="nav__link nav__link--company">
      <div class="company-image-container">
        <div>{{companyNameById(companyId)}}</div>
        <div v-if="companyDisabled" class="inactive-company-warning">DISABLED</div>
      </div>
    </router-link>

    <el-collapse v-if="!isMenuCollapsed && showMenuItem(module)" class="outer" :class="{ 'xx--disabled' : !module.hasSidebar || activeModule !== module.name }"
                 v-for="module in modules" :key="module.name" v-model="activeName" @click="collapseMenuIfOnMobile">
      <el-collapse-item v-if="!disableMenu" :name="module.name">
        <template slot="title">
          <router-link  v-if="!disableMenu" :to="module.link" class="nav__link" :class="{ 'nav__link--active' : activeModule === module.name }">
            <icon class="u-mr1" scale="0.75" :name="module.icon"></icon>
            {{ module.name }}
          </router-link>
        </template>
        <div v-if="activeModule === module.name">
          <slot name="sidebar"></slot>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="u-mt4"></div>

    <router-link v-for="module in globalModules" :key="module.name"
                 v-show="!isMenuCollapsed"
                 v-if="showMenuItem(module)"
                 :to="module.link"
                 :class="{ 'nav__link--active' : activeModule === module.name }"
                 class="nav__link">
      <icon :scale="0.75" class="u-mr1" :name="module.icon"></icon>
      <span v-show="!isMenuCollapsed" class="nav__link_info">{{module.name}}</span>
    </router-link>

    <a @click="logout(); $event.preventDefault(); collapseMenuIfOnMobile()" class="nav__link">
      <icon :scale="0.75"  name="sign-out"></icon>
      <span v-if="!isMenuCollapsed" class="nav__link_info">Logout</span>
    </a>
  </div>
</template>

<script>

import {mapActions, mapState, mapGetters} from 'vuex'
import NotificationWidget from './notification-widget.component'

export default {

  name: 'ba-header',
  components: {NotificationWidget},
  props: ['activeModule', 'disableMenu', 'canCollapse'],
  data () {
    let companyId = this.$route.params.companyId
    let modules = [
      {
        link: './',
        name: 'Enrolled Users',
        icon: 'user',
      },
      {
        link: 'emails',
        name: 'Emails',
        icon: 'envelope',
      },
      {
        link: 'sms',
        name: 'Text Messages',
        icon: 'mobile',
      },
      {
        link: 'insured-actions',
        name: 'User Actions',
        icon: 'child',
      },
      {
        link: 'insured-messages',
        name: 'User Messages',
        icon: 'comments-o',
      },
      {
        link: 'enrollment-invitations',
        name: 'Enrollment Invitations',
        icon: 'user-plus',
      },
    ]

    let isEdeliveryEnabled = this.$store.getters['shared/isEdeliveryEnabledInCompany']
    if (companyId && isEdeliveryEnabled(companyId)) {
      modules.push(
        {
          link: 'edelivery',
          name: 'E-Delivery',
          icon: 'flag',
        },
        {
          link: 'edelivery-details',
          name: 'E-Delivery Details',
          icon: 'flag',
          onlyForSuperuser: true
        }
      )
    }

    modules.push(
      {
        link: 'charts',
        name: 'Charts and Graphs',
        icon: 'bar-chart'
      },
      {
        link: 'settings',
        name: 'Settings',
        hasSidebar: true,
        icon: 'cog',
        allowsSetupChanges: true
      },
      {
        link: 'content',
        name: 'Content',
        hasSidebar: true,
        icon: 'font',
        allowsSetupChanges: true
      },
      {
        link: 'custom-pages',
        name: 'Custom Pages',
        hasSidebar: false,
        onlyForSuperuser: true,
        icon: 'envelope-square',
      },
      {
        link: 'templates',
        name: 'Templates',
        hasSidebar: true,
        icon: 'code',
        allowsSetupChanges: true
      },
      {
        link: 'appearance',
        name: 'Appearance',
        icon: 'adjust',
        allowsSetupChanges: true
      },
      {
        link: 'colors',
        name: 'Colors',
        icon: 'eyedropper',
        onlyForSuperuser: true
      },
      {
        link: {name: 'builds', query: { mode: 'mobile' }},
        name: 'Mobile Builds',
        icon: 'rocket',
        onlyForSuperuser: true
      },
      {
        link: {name: 'builds', query: { mode: 'desktop' }},
        name: 'Web Builds',
        icon: 'desktop',
        onlyForSuperuser: true
      }
    )

    let globalModules = [
      {
        link: '/administrators',
        name: 'Administrators',
        icon: 'users',
        allowsSetupChanges: true
      },
      {
        link: '/global-settings',
        name: 'Global Settings',
        icon: 'cog',
        onlyForSuperuser: true
      },
      {
        link: '/global-charts',
        name: 'Global Charts',
        icon: 'bar-chart',
        onlyForSuperuser: true
      },
      {
        link: '/current-builds',
        name: 'Current Builds',
        icon: 'rocket',
        onlyForSuperuser: true
      },
      {
        link: '/check-setting',
        name: 'Check Setting',
        icon: 'sliders',
        onlyForSuperuser: true
      },
      {
        link: '/global-insured-actions',
        name: 'Global User Actions',
        icon: 'rocket',
        onlyForSuperuser: true
      },
    ]

    return {
      modules,
      globalModules,
      companyId,
      isMenuCollapsed: true
    }
  },
  computed: {
    ...mapState('shared', ['user']),
    ...mapGetters('shared', [
      'companyNameById',
      'isFeatureEnabled',
      'isSuperuser',
      'isUserAllowedToMakeSetupChanges',
      'companyById']),
    ...mapGetters('settings', ['getSetting']),
    companyDisabled () {
      let company = this.companyById(this.companyId)
      if (!company) return false
      return !company.enabled
    },
    activeName: {
      get () {
        return [ this.activeModule ]
      },
      set (x) {
      }
    }
  },
  methods: {
    ...mapActions('login', ['logout']),
    collapseMenuIfOnMobile () {
      if (window.innerWidth > 767) {
        this.isMenuCollapsed = false
      } else {
        this.isMenuCollapsed ? this.isMenuCollapsed = false : this.isMenuCollapsed = true
      }
    },
    invalidateMenuState () {
      window.innerWidth > 767 ? this.isMenuCollapsed = false : this.isMenuCollapsed = true
    },
    showMenuItem (module) {
      let appSettingValue = this.getSetting('global.application_versions_supported')

      // If the carrier only has web version then hide mobile builds page
      if (module.name === 'Mobile Builds') {
        if (appSettingValue === 'version_web_only') {
          return false
        }
      }

      // If the carrier only has mobile version then hide desktop builds page
      if (module.name === 'Web Builds') {
        if (appSettingValue === 'version_mobile_only') {
          return false
        }
      }

      // If a menu item has onlyForSuperuser then the item will only shown if user is superuser and
      // the value is set to true.  onlyForSuperuser should never be set to false.
      if (module.onlyForSuperuser) {
        return (!module.onlyForSuperuser || (module.onlyForSuperuser && this.isSuperuser))
      }

      // If a menu item has allowsSetupChanges the the item will only be shown if allowed in isUserAllowedToMakeSetupChanges
      // and the value is set to true.  allowsSetupChanges should never be set to false.
      if (module.allowsSetupChanges) {
        return (!module.allowsSetupChanges || (module.allowsSetupChanges && this.isUserAllowedToMakeSetupChanges))
      }

      return true
    }
  },
  created () {
    window.addEventListener('resize', this.invalidateMenuState)
    this.invalidateMenuState()
  },
  destroyed () {
    window.removeEventListener('resize', this.invalidateMenuState)
  }

}
</script>
<style scoped lang="scss">
  @import "../styles/variables";
  @import "../styles/mixins";

    .inactive-company-warning {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
      color: red;
      font-size: 40px;
    }

    .company-image-container {
      position: relative;
      /*text-align: center;*/
      color: white;
    }

  .nav-wrapper {
    display: flex;
    flex-direction: column;
  }

  a {
    cursor: pointer;
  }

  .nav {
    transition: all 0.3s ease-in-out;
    vertical-align: center;
    background-color: hsl(188, 89%, 11%);
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .hidden-company {
    display: none !important;
  }

  .nav--fixed {
    position: fixed;
    height: 100%;
    z-index: 999;
    top: 0;
    left: 0;
    max-width: 240px;
    overflow-y: scroll;
    padding: 50px 15px 0;
    @media (max-width: 767px) {
      position: fixed;
      height: 100%;
      max-width: none;
      padding: 0 15px;
    }
  }

  .nav--collapsed {
    width: 4em;
    overflow: hidden;

    @media (max-width: 767px) {
      width: 100vw;
      height: 4em;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  .nav--expanded {
    padding-top: 15px;
  }

  .nav__logo {
    max-width: 160px;
    display: inline-block;
    vertical-align: middle;
  }

  .nav__logo--img {
    filter: brightness(100);
  }

  .nav__link-container {
    display: inline;
  }

  .nav__link {
    color: $white;
    display: block;
    text-decoration: none;
    margin: 0.1rem 0;
    padding: 0.5rem;
    border-radius: 6px;
    will-change: background-color;
    transition: background-color 100ms;
    line-height: 30px;
    width: 200px;
    cursor: pointer;
  }

  .nav__link_info {
    position: relative;
    bottom: 2px;
  }

  .nav__link--active {
    background-color: hsl(188, 89%, 30%);
    color: $gray--005;
  }

  .nav__link:hover {
    background-color: rgba(255, 255, 255, 0.2);
    color: $white;
  }

  // Button
  .toggle-button {
    width: 3.6em;
    height: 3.6em;
    border-radius: 50%;
    z-index: 10;
    display: flex;
    justify-content: center;
  }

  .nav__menu-toggle {
    display: none;
  }

  @media (max-width: 767px) {
    .nav__link {
      display: block;
      margin: 0;
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }

    .nav__link--company {
      @include u-truncate;

    }

    .nav--collapsed .nav__link {
      width: auto;
      min-width: 3em;
      text-align: center;
    }

    .nav__menu-toggle {
      display: inline-block;
    }
  }

</style>

<style>

  .xx--disabled .el-icon-arrow-right:before{
    content: '';
    display: none !important;
  }
  .el-collapse {
    border: none !important;
    background-color: transparent !important;
  }
  .el-collapse-item__header,
  .el-collapse-item.is-active,
  .el-collapse-item__wrap {
    background-color: transparent !important;
    border-bottom: none !important;
    font-size: 15px !important;
    font-weight: 400 !important;
  }
  .el-collapse-item__wrap {
    background-color: transparent !important;
  }
  .el-collapse-item__content {
    padding-bottom: 0 !important;
  }
  .el-icon-arrow-right {
    margin-left: 4px;
  }
  .el-tag--success {
    margin-bottom: 5px;
  }

</style>
